import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';
import { IMoodsRecommendation } from '../../interfaces/StoreTypes';

// This slice now only handles UI state - data fetching is handled by React Query
const moodsRecommendationSlice = createSlice({
    name: 'MoodsRecommendation',
    initialState: initialState.moodsRecommendation,
    reducers: {
        setMoodType: (state: IMoodsRecommendation, action) => {
            state.moodType = action.payload;
            return state;
        },
        setMoodCategory: (state: IMoodsRecommendation, action) => {
            state.moodCategory = action.payload;
            return state;
        },
        resetMoodState: (state: IMoodsRecommendation) => {
            state.moodType = null;
            state.moodCategory = null;
            return state;
        },
        // New action to clear only the category (useful for mood switching)
        clearMoodCategory: (state: IMoodsRecommendation) => {
            state.moodCategory = null;
            return state;
        },
    },
});

export const { setMoodType, setMoodCategory, resetMoodState, clearMoodCategory } = moodsRecommendationSlice.actions;

export default moodsRecommendationSlice.reducer;
